export enum ChargeType {
    Special = 1,
    Covid = 2
}